import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useResetPassword } from '../hooks/useResetPassword';
import { useLanguageContext } from '../hooks/useLanguageContext';
import translations from '../translations';
import './Signup.css';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [logoSrc, setLogoSrc] = useState('/wpk-logo.svg');
  const [localError, setLocalError] = useState(null);

  const { resetPassword, error, message, isLoading } = useResetPassword();
  const [searchParams] = useSearchParams();
  const { language, setLanguage } = useLanguageContext();

  const t = translations[language] || translations.nl;

  const email = decodeURIComponent(searchParams.get('email') || '');
  const token = searchParams.get('token') || '';
  const ref = searchParams.get('ref') || 'pvangeest';

  useEffect(() => {
    if (ref === 'wpk') {
      setLogoSrc('/wpk-logo.svg');
    } else if (ref === 'pvangeest') {
      setLogoSrc('/p-van-geest-plantenkwekerij-logo_100px.png');
    }
  }, [ref]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError(null);

    if (!email || !token) {
      setLocalError(t.resetPasswordPage.invalidLink);
      return;
    }

    if (password !== repeatPassword) {
      setLocalError(t.resetPasswordPage.passwordsDontMatch);
      return;
    }

    const success = await resetPassword(email, token, password);

    if (success) {
      setTimeout(() => {
        window.location.href = `/login?ref=${ref}`;
      }, 1500);
    }
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
          <select
            className="language-select"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="nl">Nederlands</option>
            <option value="en">English</option>
            <option value="de">Deutsch</option>
            <option value="fr">Français</option>
          </select>
        </div>

        <div className="logo-container">
          <img src={logoSrc} alt="Logo" className="logo" />
        </div>

        <h3>{t.resetPasswordPage.title}</h3>
        <p>{t.resetPasswordPage.intro}</p>

        <label>{t.email}:</label>
        <input
          type="email"
          value={email}
          disabled
          className="input-field"
        />

        <label>{t.resetPasswordPage.newPassword}:</label>
        <input
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          required
          className="input-field"
        />

        <label>{t.resetPasswordPage.repeatPassword}:</label>
        <input
          type="password"
          onChange={(e) => setRepeatPassword(e.target.value)}
          value={repeatPassword}
          required
          className="input-field"
        />

        <button disabled={isLoading} className="submit-button">
          {t.resetPasswordPage.button}
        </button>

        {message && (
          <div style={{ marginTop: '10px', color: '#2e7d32', fontSize: '0.9rem' }}>
            {message}
          </div>
        )}

        {localError && <div className="error-message">{localError}</div>}
        {error && <div className="error-message">{error}</div>}
      </form>
    </div>
  );
};

export default ResetPassword;